import axios from 'axios';
import { useEffect, useState } from 'react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const ops = {
  get: (p, params) => axios.get(`${API}/ops${p}`, { params }).then(r => r.data),
  post: (p, body) => axios.post(`${API}/ops${p}`, body).then(r => r.data),
  put: (p, body) => axios.put(`${API}/ops${p}`, body).then(r => r.data),
  patch: (p, body) => axios.patch(`${API}/ops${p}`, body).then(r => r.data),
  del: (p) => axios.delete(`${API}/ops${p}`).then(r => r.data),
};

export const MGMT_ROLES = ['owner', 'director', 'admin', 'area_manager'];
export const isMgmt = (user) => MGMT_ROLES.includes(user?.ops_role || user?.role);
export const isCompany = (user) => ['owner', 'director', 'admin'].includes(user?.ops_role || user?.role);

export const STATUS_STYLES = {
  pending: 'bg-slate-100 text-slate-700', draft: 'bg-amber-50 text-amber-700', submitted: 'bg-blue-50 text-blue-700', under_review: 'bg-indigo-50 text-indigo-700',
  returned: 'bg-rose-50 text-rose-700', approved: 'bg-emerald-50 text-emerald-700', missed: 'bg-red-100 text-red-700', not_submitted: 'bg-slate-100 text-slate-500',
  open: 'bg-rose-50 text-rose-700', in_progress: 'bg-amber-50 text-amber-700', submitted_for_verification: 'bg-blue-50 text-blue-700', verified_closed: 'bg-emerald-50 text-emerald-700',
  critical: 'bg-red-600 text-white', high: 'bg-orange-500 text-white', medium: 'bg-amber-100 text-amber-800', low: 'bg-slate-100 text-slate-600', normal: 'bg-slate-100 text-slate-600',
};
export const label = (s) => (s || '').replace(/_/g, ' ');

export const Badge = ({ value, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${STATUS_STYLES[value] || 'bg-slate-100 text-slate-600'}`}>{label(value)}</span>
);

export const fmt = (v, unit) => {
  if (v === null || v === undefined) return '—';
  if (unit === '$') return `$${Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
  if (unit === '%') return `${Number(v).toFixed(1)}%`;
  if (unit === 'sec') return `${Number(v).toFixed(0)}s`;
  return Number(v).toLocaleString();
};

export function useStores() {
  const [stores, setStores] = useState([]);
  const [storeId, setStoreIdState] = useState(() => localStorage.getItem('ops_store_id') || '');
  useEffect(() => { ops.get('/stores').then(s => { setStores(s); if (!s.find(x => x.id === storeId) && s[0]) { setStoreIdState(s[0].id); localStorage.setItem('ops_store_id', s[0].id); } }).catch(() => {}); }, []); // eslint-disable-line
  const setStoreId = (id) => { setStoreIdState(id); localStorage.setItem('ops_store_id', id); };
  return { stores, storeId, setStoreId, store: stores.find(s => s.id === storeId) };
}

export const StoreSwitcher = ({ stores, storeId, setStoreId, className = '' }) => (
  <select value={storeId} onChange={e => setStoreId(e.target.value)} className={`rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-[#3E2418] shadow-sm focus:outline-none focus:ring-2 focus:ring-[#F26522] ${className}`} data-testid="store-switcher">
    {stores.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
  </select>
);

export async function uploadFile(file) {
  const fd = new FormData(); fd.append('file', file);
  const r = await axios.post(`${API}/upload`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  return r.data;
}
